// extracted by mini-css-extract-plugin
export default {"image":"y1-z","loaded":"z1-z"};